<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Usuarios</h2>
            <!-- Filtros -->
            <v-row>
                <v-col cols="6" lg="5">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por nombres, apellidos o email" outlined dense clearable></v-text-field>
                </v-col>
                <v-col cols="3" lg="3">
                    <v-select v-model="FilterArea" :items="Larea" item-text="n_area" item-value="oid" label="Filtro por Área" outlined dense multiple clearable />
                </v-col>
                <v-col cols="3" lg="3">
                    <v-select v-model="FilterRol" :items="roles" item-text="n_rol" item-value="oid" label="Filtro por Rol" outlined dense multiple clearable />
                </v-col>
            </v-row>
            <v-row class="mb-1">
                <v-col cols="12" md="3">
                    <v-btn class="perfil-btn-primary" dark block :loading="sincronizando" @click="confirmSyncDialog = true">
                        <v-icon left>mdi-account-sync-outline</v-icon>
                        Sincronizar funcionarios
                    </v-btn>
                </v-col>
                <!-- <v-col cols="12" md="3">
                    <v-btn class="perfil-btn-primary" dark @click="nueva">
                        <v-icon left>mdi-account-plus</v-icon> Registrar usuario
                    </v-btn>
                </v-col> -->
            </v-row>
            <!-- <v-btn style="color: white;background-color: #0084D1;" dark class="mb-2" @click="actualizar">Actualizar Listado</v-btn> -->

            <!-- Diálogo para crear un nueva -->
            <v-dialog v-model="dialog" max-width="70%">
                <!-- <template v-slot:activator="{ on }">
                    <v-btn style="color: white;background-color: #0084D1;" dark class="mb-2" v-on="on" @click="nueva">Nuevo</v-btn>
                </template> -->
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" lazy-validation>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <strong>Nombres:</strong><br>{{ dato.names }}
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <strong>Apellidos:</strong><br>{{ dato.surname }}
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <strong>Email:</strong><br>{{ dato.email }}
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select v-model="dato.oid_rol" :items="roles" item-text="n_rol" item-value="oid" label="Rol" :rules="[rules.select]" clearable />
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-select v-model="dato.activo" :items="Ops" item-text="nombre" item-value="oid" label="Activo" :rules="[rules.select]" clearable />
                                        </v-col>
                                    </v-row>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="perfil-btn-outline" outlined @click="dialog=false" :disabled="dialog_guardando"> Cancelar </v-btn>
                        <v-btn :loading="dialog_guardando" :disabled="!formValid || dialog_guardando" class="perfil-btn-primary" @click="guardar" >
                            {{ isNew ? 'Guardar' : 'Actualizar' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo para crear un nueva -->
            <v-dialog v-model="dialogN" max-width="80%">
                <!-- <template v-slot:activator="{ on }">
                    <v-btn style="color: white;background-color: #0084D1;" dark class="mb-2" v-on="on" @click="nueva">Nuevo</v-btn>
                </template> -->
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialogN = false"> <v-icon>mdi-close</v-icon> </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" lazy-validation>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.document" :rules="[rules.required]" label="Nro Identificación" required outlined dense class="perfil-field" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.names" :rules="[rules.required]" label="Nombres" required outlined dense class="perfil-field" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field v-model="dato.surname" :rules="[rules.required]" label="Apellidos" required outlined dense class="perfil-field" clearable/>
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <v-text-field v-model="dato.email" :rules="[rules.email]" label="Correo" clearable outlined dense hide-details="auto" class="perfil-field"/>
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <v-autocomplete v-model="dato.supervisor_id" :items="datosPersonas" item-text="nombreCompleto" item-value="oid" label="Funcionario enlazado"
                                            outlined dense clearable class="perfil-field" no-data-text="No se encontraron funcionarios"
                                            @change="seleccionarFuncionario" />
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <v-select v-model="dato.oid_rol" :items="roles" item-text="n_rol" item-value="oid" label="Rol" :rules="[rules.select]" clearable outlined dense hide-details="auto" class="perfil-field"/>
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <v-select v-model="dato.activo" :items="Ops" item-text="nombre" item-value="oid" label="Activo" :rules="[rules.select]" clearable outlined dense hide-details="auto" class="perfil-field" />
                                        </v-col>
                                        <!-- <v-col cols="12" md="4" class="py-1">
                                            <v-select v-model="dato.oid_rol" :items="roles" item-text="n_rol" item-value="oid" label="Rol" :rules="[rules.select]" clearable />
                                        </v-col>
                                        <v-col cols="12" md="4" class="py-1">
                                            <v-select v-model="dato.activo" :items="Ops" item-text="nombre" item-value="oid" label="Activo" :rules="[rules.select]" clearable />
                                        </v-col> -->
                                    </v-row>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="perfil-btn-outline" outlined @click="dialogN=false" :disabled="dialog_guardando"> Cancelar </v-btn>
                        <v-btn :loading="dialog_guardando" :disabled="!formValid || dialog_guardando" class="perfil-btn-primary" @click="guardarN" >
                            {{ isNew ? 'Guardar' : 'Actualizar' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-data-table :headers="headers" :items="filtered" item-key="oid" :items-per-page="30">
                <template v-slot:items="props">
                    <td>{{ props.item.names }}</td>
                    <td>{{ props.item.surname }}</td>
                </template>
                <template v-slot:item.activo="{ item }">
                    {{ item.activo ? 'SI' : 'NO' }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdi-eye</v-icon>
                        </template>
                        <span>Detalle</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom v-if="item.oid_rol != 2">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" color="red" v-on="on" @click="confirmarEliminar(item.oid)">mdi-delete</v-icon>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip> -->
                </template>
            </v-data-table>
        
            <!-- Formulario de creación/edición -->      
            <v-form ref="form" @submit.prevent="guardar">
            </v-form>

            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="70%">
                <v-card>
                <v-card-title class="headline">Detalle</v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-row>
                                <v-col cols="12">
                                    <h3 class="text-center" style="color: #e4b510;">Información General</h3>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Nro Identificación:</strong><br>{{ dato.document }}
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Nombres:</strong><br>{{ dato.names }}
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Apellidos:</strong><br>{{ dato.surname }}
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Email:</strong><br>{{ dato.email }}
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Rol:</strong><br>{{ getRolN(dato.oid_rol) }}
                                </v-col>
                                <v-col cols="12" md="4">
                                    <strong>Activo:</strong><br>{{ dato.activo ? 'Si' : 'No' }}
                                </v-col>
                            </v-row>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="perfil-btn-outline" outlined @click="dialogdetail = false;">Cerrar</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="500px">
                <v-card>
                <v-card-title class="headline">Confirmar eliminación</v-card-title>
                <v-card-text>
                    ¿Estás seguro de que deseas eliminar este registro?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                    <v-btn class="perfil-btn-outline" outlined @click="cancelarEliminar">No</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando .....</v-card-title>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmSyncDialog" max-width="500" persistent>
                <v-card class="text-center pa-6">
                    <v-icon color="orange lighten-1" size="72" class="mb-4">
                        mdi-alert-circle-outline
                    </v-icon>

                    <div class="text-h5 font-weight-bold mb-3">
                        Sincronizar funcionarios
                    </div>

                    <div class="grey--text text--darken-1 mb-5">
                        Se crearán o actualizarán usuarios con acceso al sistema
                        a partir de los funcionarios que tengan correo institucional válido.
                        <br><br>
                        No se tomarán en cuenta correos temporales de prueba.
                    </div>

                    <v-row>
                        <v-col cols="6">
                            <v-btn class="perfil-btn-outline" outlined @click="confirmSyncDialog = false" :disabled="sincronizando">
                                Cancelar
                            </v-btn>
                        </v-col>

                        <v-col cols="6">
                            <v-btn class="perfil-btn-primary" dark :loading="sincronizando" @click="sincronizarFuncionarios">
                                Confirmar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
            
            <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
                {{ snackbarMensaje }}
                <template v-slot:action="{ attrs }">
                    <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
                </template>
            </v-snackbar>

        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import { setRols, getRolN, getAreaN, setAreas } from '@/utils/validators';
  
export default {
    data() {
        return {
            datos: [], Larea: [], roles: [],
            dato: {
                oid: 0,
                document: '',
                names: '',
                surname: '',
                email: '',
                oid_rol: null,
                oid_area: null,
                activo: null,
                supervisor_id: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
            dialog: false, dialogN: false,
            formTitle: '', // Título del diálogo
            dialogdetail: false,
            showConfirmDialog: false,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',
            rules: {
                required: v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Campo obligatorio',
                maxValue: max => v =>
                    (!v || Number(v) <= max) || `El valor no puede ser mayor a ${max}`,
                select: v => (v !== null && v !== undefined && v !== '') || 'Selecciona una opción',
                email: v => {
                    if (!v) return 'Campo obligatorio';

                    //const re = /^[a-zA-Z0-9._%+-]+@(un\.org|policia\.bo)$/i;
                    const re = /^[a-zA-Z0-9._%+-]+@(policia\.bo)$/i;

                    return re.test(String(v).trim())
                        || 'Solo se permiten correos @policia.bo';
                },
            },
            formValid: false,
            FilterArea: [], FilterRol: [],
            sincronizando: false, confirmSyncDialog: false,
            datosPersonas: [],
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Nombres', value: 'names' },
                { text: 'Apellidos', value: 'surname' },
                { text: 'Email', value: 'email' },
                { text: 'Rol', value: 'rol' },
                { text: 'Área', value: 'area' },
                { text: 'Activo', value: 'activo' },
            ];

            return baseHeaders;
        },
        filtered() {
            // Si no hay búsqueda, devuelve todo
            let filteredData = this.datos || [];

            // 1️⃣ Filtro por tipo (si hay seleccionados)
            if (this.FilterArea && this.FilterArea.length > 0) {
                filteredData = filteredData.filter(item =>
                    this.FilterArea.includes(Number(item.oid_area))
                );
            }
            // 1️⃣ Filtro por tipo (si hay seleccionados)
            if (this.FilterRol && this.FilterRol.length > 0) {
                filteredData = filteredData.filter(item =>
                    this.FilterRol.includes(Number(item.oid_rol))
                );
            }

            // 2️⃣ Filtro por búsqueda (título o consecutivo)
            if (this.search && this.search.trim() !== '') {
                const texto = this.search.toLowerCase();

                filteredData = filteredData.filter(dato => {
                    const name      = (dato.name || '').toLowerCase();
                    const surname = (dato.surname || '').toLowerCase();
                    const email = (dato.email || '').toLowerCase();

                    return (
                        name.includes(texto) ||
                        surname.includes(texto) ||
                        email.includes(texto)
                    );
                });
            }

            return filteredData;
        },
        userName() {
            const user = localStorage.getItem('userName'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },
    },
    mounted() {
        this.listar();
    },
    methods: {
        // Obtener la lista
        async listar() {
            try {
                this.roles = await setRols();
                this.Larea = await setAreas();

                const response = await axios.get('api/Users/Listar');
                this.datos = response.data.map(h => ({
                    ...h,
                    rol: getRolN(h.oid_rol),
                    area: getAreaN(h.oid_area),
                    act: h.activo === 1 ? 'Si' : 'No'
                }));

                const personas = await axios.get('api/PersonaInfoGenerals/ListarCompleto?page=1&pageSize=50000');

                this.datosPersonas = personas.data.data.map(p => ({
                    ...p,
                    nombreCompleto: `${p.documento || ''} - ${p.nombres || ''} ${p.primero_apellido || ''} ${p.segundo_apellido || ''} ${p.tercer_apellido || ''}`.trim()
                }));
            } catch (error) {
                console.error(error);
            }
        },
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/Users/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Usuario';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = {
                oid: 0,
                document: '',
                names: '',
                surname: '',
                email: '',
                oid_rol: null,
                oid_area: 1,
                activo: null,
                supervisor_id: null,
            };
            this.isNew = true;
            this.formTitle = 'Crear Usuario';
            this.dialogN = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;
            });
        },
        async actualizar() {
            try {
                await axios.post('api/Users/SyncInline');
                this.listar();

                this.snackbarMensaje = "Listado actualizado correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            } catch (error) {
                console.error(error);
            }
        },
        async sincronizarFuncionarios() {
            this.sincronizando = true;

            try {
                const response = await axios.post('api/Users/SyncInline');

                await this.listar();

                this.confirmSyncDialog = false;

                this.snackbarMensaje =
                    response.data?.message ||
                    'Sincronización realizada correctamente';

                this.snackbarColor = 'success';
                this.snackbar = true;

            } catch (error) {
                console.error(error);

                this.snackbarMensaje =
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    'Error al sincronizar funcionarios';

                this.snackbarColor = 'error';
                this.snackbar = true;

            } finally {
                this.sincronizando = false;
            }
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Usuario';
            this.dialogN = true;
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/Users/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/Users/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0, 
                    names: '',
                    surname: '',
                    email: '',
                    oid_rol: null,
                    oid_area: null,
                    activo: null
                };
                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Se guardo correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Guardar creada o actualizada
        async guardarN() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/Users/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/Users/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0, 
                    document: '',
                    names: '',
                    surname: '',
                    email: '',
                    oid_rol: null,
                    oid_area: null,
                    activo: null,
                    supervisor_id: null,
                };
                // Después de guardar exitosamente el registro:
                this.dialogN = false;
                await this.listar();
                
                this.snackbarMensaje = "Se guardo correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/Users/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        getRolN, getAreaN,
        seleccionarFuncionario(oidPersona) {
            const persona = this.datosPersonas.find(x => x.oid === oidPersona);

            if (!persona) return;

            this.dato.document = persona.documento || '';
            this.dato.names = persona.nombres || '';
            this.dato.surname = `${persona.primero_apellido || ''} ${persona.segundo_apellido || ''} ${persona.tercer_apellido || ''}`.trim();
            this.dato.email = persona.correo || '';
        }
    },
};
</script> 
<style>
    p {
        font-family: 'Heebo', sans-serif !important;
    }
    h1 {
        font-family: 'Heebo', sans-serif !important;
    }
    
    .incidente-root {
        padding-top: 0 !important;
        margin-top: 0 !important;
        width: 100% !important;
        align-self: flex-start !important;
        margin-left: 1%;
    }
</style>